var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8023_9913)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8023_9913",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8023_9913)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8023_9913)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8023_9913",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 15,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H4V19H19V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8023_9913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 4H11.7813C11.3125 4 11.2187 4.1875 10.75 4.75L4.5625 10.9375C3.8125 11.6875 3.8125 12.9063 4.5625 13.6563L9.3437 18.4375C10.0937 19.1875 11.3125 19.1875 12.0625 18.4375L18.25 12.25C18.7187 11.875 19 11.6875 19 11.125V4.9375C19 4.375 18.625 4 18.0625 4ZM12.1562 17.0312L11.5 17.6875C11.125 18.0625 10.4688 18.0625 10.0938 17.6875L5.3125 12.9062C4.9375 12.5312 4.9375 11.875 5.3125 11.5L5.9687 10.8438L6.625 10.1875L11.4063 5.4062C11.6875 5.2187 12.0625 4.9375 12.25 4.9375H17.5938C17.875 4.9375 18.0625 5.125 18.0625 5.3125V10.6562C18.0625 10.9375 17.875 11.3125 17.5938 11.5L12.8125 16.2813L12.1562 17.0312ZM13.1875 7.0937C12.4375 7.8437 12.4375 9.0625 13.1875 9.8125C13.9375 10.5625 15.1562 10.5625 15.9062 9.8125C16.6562 9.0625 16.6562 7.8437 15.9062 7.0937C15.1562 6.3437 13.9375 6.3437 13.1875 7.0937ZM15.25 9.1562C14.875 9.5313 14.2188 9.5313 13.8438 9.1562C13.4687 8.7812 13.4687 8.125 13.8438 7.75C14.2188 7.375 14.875 7.375 15.25 7.75C15.625 8.2188 15.625 8.7812 15.25 9.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6063 13.7589L9.29736 9.45007L10.2254 8.52197L14.5343 12.8309L13.6063 13.7589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7098 15.7179L7.40088 11.4091L8.32888 10.481L12.6378 14.7899L11.7098 15.7179Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8023_9913",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8023_9913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/Properties.2b20ab7fb4589176e6c7bbf9c0b8cc48.svg";
export { ForwardRef as ReactComponent };